<svg class="logo logo--login" viewBox="0 0 111 39.96">
  <use xlink:href="#ab-logo"></use>
</svg>

<form class="form form--login" name="pwResetForm" id="pwResetForm" novalidate [formGroup]="form">
  <app-error-notification [errors]="errorMessages"></app-error-notification>

  <div class="mb-0150 auth-card mat-card--simple mat-card--border">
    <div class="auth-card__header">
      <h1 class="auth-card__title">Reset Password</h1>
      <p class="auth-card__subtitle">Enter your new password below.</p>
    </div>

    <div class="auth-card__content">
      <mat-form-field [hideRequiredMarker]="true" class="mb-0100">
          <mat-label>Password</mat-label>

          <input matInput id="password"
            name="password"
            autocomplete="new-password"
            [type]="pwShown ? 'text' : 'password'"
            formControlName="password"
            />

          <span matSuffix
            mat-icon-button
            aria-label="Show"
            style="padding-right: 0.5em; display: inline-block;"
            [ngStyle]="{'color': pwShown ? '#006EC5' : '#C3C9D9'}"
            (click)="pwShown = !pwShown">
            <mat-icon fontSet="far" fontIcon="fa-eye"></mat-icon>
          </span>

          <app-input-error [formControlItem]="form.controls['password']"></app-input-error>
      </mat-form-field>

      <mat-form-field [hideRequiredMarker]="true" class="mb-0">
        <mat-label>Confirm Password</mat-label>

        <input matInput id="passwordConfirmation"
          name="passwordConfirmation"
          autocomplete="new-password"
          [type]="pwShown ? 'text' : 'password'"
          formControlName="passwordConfirmation"/>

        <span matSuffix
          mat-icon-button
          aria-label="Show"
          style="padding-right: 0.5em; display: inline-block;"
          [ngStyle]="{'color': pwShown ? '#006EC5' : '#C3C9D9'}"
          (click)="pwShown = !pwShown">
          <mat-icon fontSet="far" fontIcon="fa-eye"></mat-icon>
        </span>

        <app-input-error [formControlItem]="form.controls['passwordConfirmation']"></app-input-error>
      </mat-form-field>
    </div>
  </div>

  <div class="mb-0100">
    <button class="btn btn--full btn--lg" type="button" [disabled]="isSubmitting || form.invalid" (click)="onResetClick()">Change Password</button>
  </div>
</form>
